/* eslint-disable */
import _ from 'underscore';
import parser from 'cron-parser';
var cron;
var year = {};
var frequency = {
  DAILY: 0,
  WEEKLY: 1,
  MONTHLY: 2,
  ONCE: 3,
  HOURLY: 4
};
function init(cronString) {
  if (cronString == null || cronString == '') {
    return false;
  }
  var tokens = cronString.split(' ');
  if (tokens.length > 5) {
    year = tokens[tokens.length - 1];
    cronString = cronString.replace(year, '');
  }
  cronString = '* ' + cronString;
  cron = parser.parseExpressionSync(cronString);
  return true;
}
function parse(cronString) {
  var cronModel = undefined;
  if (init(cronString)) {
    var minute = getMinute(), hour = getHour(), dayofWeek = getDayofWeek(), dayofMonth = getDayofMonth(), month = getMonth();
    cronModel = {
      frequency: getFrequency()
    };
    switch (cronModel.frequency) {
      case frequency.ONCE:
        cronModel.year = year;
        cronModel.month = month[0];
        cronModel.dayOfMonth = dayofMonth[0];
        cronModel.hour = hour[0];
        break;
      case frequency.MONTHLY:
        cronModel.dayOfMonth = dayofMonth[0];
        cronModel.hour = hour[0];
        break;
      case frequency.WEEKLY:
        cronModel.dayOfWeek = dayofWeek[0];
        cronModel.hour = hour[0];
        break;
      case frequency.DAILY:
        cronModel.hour = hour[0];
        break;
      case frequency.HOURLY:
        cronModel.min = minute[0];
        break;
    }
  }
  return cronModel;
}
function getYear() {
  return year;
}
function getMonth() {
  return cron._fields.month;
}
function getDayofMonth() {
  return cron._fields.dayOfMonth;
}
function getDayofWeek() {
  return cron._fields.dayOfWeek;
}
function getHour() {
  return cron._fields.hour;
}
function getMinute() {
  return cron._fields.minute;
}
function generate(options) {
  var defaults = {
    min: '0',
    hour: '*',
    dayOfWeek: '*',
    dayOfMonth: '*',
    month: '*',
    year: '*'
  };
  return _.template('{{min}} {{hour}} {{dayOfMonth}} {{month}} {{dayOfWeek}} {{year}}')(_.defaults(options, defaults));
}
function setHourlyCron(min) {
  min = min || 0;
  if (min < 0 || min > 60) {
    return '';
  }
  return generate({
    min: min
  });
}
function setDailyCron(hour) {
  if (hour < 0 || hour > 23) {
    return '';
  }
  return generate({
    hour: hour
  });
}
function setWeeklyCron(hour, dayOfWeek) {
  if (hour < 0 || hour > 23 || dayOfWeek < 0 || dayOfWeek > 6) {
    return '';
  }
  return generate({
    hour: hour,
    dayOfWeek: dayOfWeek
  });
}
function setMonthlyCron(hour, dayOfMonth) {
  if (hour < 0 || hour > 23 || dayOfMonth < 1 || dayOfMonth > 31) {
    return '';
  }
  return generate({
    hour: hour,
    dayOfMonth: dayOfMonth
  });
}
function setOnceCron(hour, dayOfMonth, month, year) {
  if (hour < 0 || hour > 23 || dayOfMonth < 1 || dayOfMonth > 31 || month < 1 || month > 12 || year < 1 || year > 9999) {
    return '';
  }
  return generate({
    hour: hour,
    dayOfMonth: dayOfMonth,
    month: month,
    year: year
  });
}
function getFrequency() {
  if (year.length > 1) {
    return frequency.ONCE;
  } else if (cron._fields.dayOfMonth.length === 1) {
    return frequency.MONTHLY;
  } else if (cron._fields.dayOfWeek.length === 1) {
    return frequency.WEEKLY;
  } else if (cron._fields.hour.length === 1) {
    return frequency.DAILY;
  } else {
    return frequency.HOURLY;
  }
}
export default {
  getYear: getYear,
  getMonth: getMonth,
  getDayofMonth: getDayofMonth,
  getDayofWeek: getDayofWeek,
  getHour: getHour,
  getMinute: getMinute,
  setHourlyCron: setHourlyCron,
  setDailyCron: setDailyCron,
  setWeeklyCron: setWeeklyCron,
  setMonthlyCron: setMonthlyCron,
  setOnceCron: setOnceCron,
  getFrequency: getFrequency,
  frequency: frequency,
  parse: parse,
  init: init
};

